import React, { useEffect, useState } from "react";
import { DollarSign } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./paymentTemplateStyles.css";
import Pagelayout from "../../components/Pagelayout";
import { fetchPayTemplate } from "../../parollAPIs";
import { useDispatch, useSelector } from "react-redux";
import { setSingleViewData } from "../../payrollSlice";
import { Skeleton } from "@mui/material";
import { VIEW_TYPE } from "../../payrollEnums";

const PayTemplatePayroll = () => {
  const handleCreatePaytemplate = () => {
    navigate("create");
  };
  const navigate = useNavigate();
  const { listData, filterData, paginationData, searchInput } = useSelector(
    (state) => state.payrollSlice
  );
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSingleViewData(null));
  }, [dispatch]);

  useEffect(() => {
    fetchPayTemplate({
      body: {
        page: paginationData.currentPage || 1,
        limit: 12,
        search: searchInput || "",
        category:
          filterData?.category?.map((item) => item?.value).join(",") || "",
      },
      viewType:VIEW_TYPE.LIST,
      setLoading,
    });
  }, [filterData, paginationData.currentPage, searchInput]);

  const conversion = (key) => {
    switch (key) {
      case "FIXED":
        return "FIXED";

      case "BASICPERCENT":
        return "% OF BASIC";

      case "CTCPERCENT":
        return "% OF CTC";

      default:
        return "FIXED";
    }
  };



  //get selected card
  const selectedCard = (data) => {
    navigate(`create`, {
      state: { _id: data?._id },
    });
  };

 

  return (
    <Pagelayout
      pageName="Pay Template"
      headerLayout={1}
      handleCreateBtn={handleCreatePaytemplate}
      filter={false}
      pagination={false}
      // searchBox={false}
    >
      <div className="salary-grid">
        {loading
          ? Array.from({ length: 4 }).map((_, index) => (
              <CardSkeleton index={index} />
            ))
          : listData &&
            listData?.map((item, index) => {
              const monthlyTotal = [...item.payHeads, item.basic]?.reduce(
                (acc, component) => acc + (component?.monthly || 0),
                0
              );
              const yearlyTotal = [...item.payHeads, item.basic]?.reduce(
                (acc, component) => acc + (component?.yearly || 0),
                0
              );

              return (
                <div
                  key={index}
                  className="salary-card"
                  onClick={() => selectedCard(item)}>
                  <div className="salary-header">
                    <div className="salary-title-section">
                      <div>
                        <div className="salary-title">{item.tempName}</div>
                        <div className="salary-amount">
                          {item?.totalCtc?.toFixed(2)} {"AED"}
                        </div>
                         <div  className="salary-content">
                          Period of Time : {item?.period} 
                        </div>
                      </div>
                      {/* <div className="fixed-pay-badge">FIXED PAY</div> */}
                    </div>
                  </div>

                  {/* <div className="salary-content">
                    <div className="table-header">
                      <div>COMPONENTS</div>
                      <div>CALCULATION TYPE</div>
                      <div>MONTHLY</div>
                      <div>YEARLY</div>
                    </div>

                    {[...item.payHeads, item.basic]?.map((component, idx) => (
                      <div key={idx} className="table-row">
                        <div className="row-content">
                          <div
                            className={`component-cell ${
                              component?.isBlue ? "blue" : ""
                            }`}
                          >
                            {component?.isBlue && <DollarSign />}
                            {component?.category}
                          </div>
                          <div className="calculation-cell">
                            {conversion(component.calculationType)}
                            {component?.percentage && (
                              <span className="percentage">
                                ({component?.percentage})
                              </span>
                            )}
                          </div>
                          <div className="value-cell">
                            {component?.monthly?.toFixed(2)}
                          </div>
                          <div className="value-cell">
                            {component?.yearly?.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    ))}

                    <div className="total-row">
                      <div>TOTAL</div>
                      <div></div>
                      <div>{monthlyTotal.toFixed(2)}</div>
                      <div>{yearlyTotal.toFixed(2)}</div>
                    </div>
                  </div> */}
                </div>
              );
            })}
      </div>
    </Pagelayout>
  );
};

export default PayTemplatePayroll;

const CardSkeleton = ({ index }) => {
  return (
    <div key={index} className="salary-card">
      <div className="salary-header">
        <div className="salary-title-section">
          <div>
            <Skeleton variant="text" width={150} height={30} />
            <Skeleton variant="text" width={100} height={20} />
          </div>
          <Skeleton variant="rectangular" width={80} height={25} />
        </div>
      </div>

      <div className="salary-content">
        <div className="table-header">
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={80} height={20} />
        </div>

        {Array.from({ length: 4 }).map((_, idx) => (
          <div key={idx} className="table-row">
            <div className="row-content">
              <Skeleton variant="text" width={120} height={20} />
              <Skeleton variant="text" width={100} height={20} />
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="text" width={80} height={20} />
            </div>
          </div>
        ))}

        <div className="total-row">
          <Skeleton variant="text" width={60} height={20} />
          <Skeleton variant="text" width={0} height={20} />
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={80} height={20} />
        </div>
      </div>
    </div>
  );
};
